import connect from 'components/Shared/connect';
import { ContentArea, Registry } from 'components/Shared/Markdown';
import { registry } from 'views/ContentPage/components/themes/BGH/registry';
import { isContentPage } from 'models/ContentPageModel';

export default connect(state => ({
  content: isContentPage(state.currentPage) ? state.currentPage.content : []
}))(({ content }) => (
  <Registry registry={registry}>
    <ContentArea content={content} />
  </Registry>
));
